/**
 * Centralized query key factory.
 *
 * Using an object-based factory keeps keys type-safe, refactorable,
 * and easy to invalidate at any granularity (e.g. invalidate all
 * bookings vs a single booking).
 */
export const queryKeys = {
  // ── Bookings ──────────────────────────────────────────────────────────
  bookings: {
    all: ["bookings"] as const,
    lists: () => ["bookings", "list"] as const,
    list: (params?: {
      status?: string;
      service_type?: string;
      page?: number;
    }) => ["bookings", "list", params ?? {}] as const,
    detail: (id: number) => ["bookings", "detail", id] as const,
    track: (id: number) => ["bookings", "track", id] as const,
    byBooking: (id: number) =>
      ["bookings", "list", "detail", "track", id] as const,
    scheduledJobs: () => ["bookings", "scheduled-jobs"] as const,
  },

  // ── Quotes ────────────────────────────────────────────────────────────
  quotes: {
    all: ["quotes"] as const,
    list: (params?: { booking_id?: number; status?: string }) =>
      ["quotes", "list", params ?? {}] as const,
    detail: (id: number) => ["quotes", "detail", id] as const,
  },

  // ── Vehicles ──────────────────────────────────────────────────────────
  vehicles: {
    all: ["vehicles"] as const,
    list: () => ["vehicles", "list"] as const,
    detail: (id: number) => ["vehicles", "detail", id] as const,
  },

  // ── Messages (chat) ───────────────────────────────────────────────────
  messages: {
    all: ["messages"] as const,
    byBooking: (bookingId: number) =>
      ["messages", "booking", bookingId] as const,
  },

  // ── Notifications ─────────────────────────────────────────────────────
  notifications: {
    all: ["notifications"] as const,
    list: (page?: number) => ["notifications", "list", page ?? 1] as const,
    // Kept outside the "notifications" prefix: the list cache updaters expect paginated data.
    unreadCount: ["notifications-unread-count"] as const,
  },
} as const;
